import { observable, action, computed } from "mobx";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class NavigatorStore {
  constructor(http) {
    this.http = http;
    this.init();
  }

  frameworkListDisplayType = {
    PUBLISHED: "PUBLISHED",
    UNPUBLISHED: "UNPUBLISHED",
  };

  @observable
  currentFrameworkListDisplayType = "";

  @observable
  frameworkListLabel = "";

  @observable
  frameworkListLabelForBurgerMenu = "";

  @action
  init = async () => {
    if (IS_BIRD_APP) {
      this.currentFrameworkListDisplayType =
        this.frameworkListDisplayType.PUBLISHED;
      this.frameworkListLabel = "Output reporting Frameworks";
    }
  };

  @action
  setFrameworkListLabel = (label) => {
    this.frameworkListLabel = label;
  };

  @action
  setFrameworkListLabelForBurgerMenu = (label) => {
    this.frameworkListLabelForBurgerMenu = label;
  };

  @action
  setCurrentFrameworkListDisplayType = (value) => {
    this.currentFrameworkListDisplayType = value;
  };

  @action
  switchCurrentFrameworkListDisplayType = () => {
    if (
      this.currentFrameworkListDisplayType ===
      this.frameworkListDisplayType.PUBLISHED
    ) {
      this.currentFrameworkListDisplayType =
        this.frameworkListDisplayType.UNPUBLISHED;
      this.setFrameworkListLabel(
        "Output reporting Frameworks (not yet in BIRD)"
      );
      this.setFrameworkListLabelForBurgerMenu("Frameworks (not yet in BIRD)");
    } else {
      this.currentFrameworkListDisplayType =
        this.frameworkListDisplayType.PUBLISHED;
      this.setFrameworkListLabel("Output reporting Frameworks (in BIRD)");
      this.setFrameworkListLabelForBurgerMenu("Frameworks (in BIRD)");
    }
  };

  @computed
  get getCurrentFrameworkListDisplayType() {
    return this.currentFrameworkListDisplayType;
  }

  @computed
  get getFrameworkListDisplayType() {
    return this.frameworkListDisplayType;
  }

  @computed
  get getFrameworkListLabel() {
    return this.frameworkListLabel;
  }

  @computed
  get getFrameworkListLabelForBurgerMenu() {
    return this.frameworkListLabelForBurgerMenu;
  }
}
